/**
 * Theme tokens - Design system tokens for custom theme
 * 
 * Note: Hooks are only available in client components.
 * Use type-only imports for server components.
 */

// Export types and utilities that are safe for server-side
export * from "./interactive";
export * from "./tokens";
export { GlobalGrainOverlay } from "./GlobalGrainOverlay";
export { ThemeColorMeta } from "./ThemeColorMeta";

// Export hooks separately to avoid SSR issues
// These should only be imported in client components
export type { DashboardMode } from "@/components/dashboard/DashboardThemeProvider";
export {
  useDashboardTheme,
  useDashboardThemeTokens,
  useThemeTokens,
} from "./hooks";

